import { TCompletenessItemKey } from "@/data/consultant-profiles";

export const getProfileDataKeys: (isPrivateProfile: boolean) => TCompletenessItemKey[] = (
  isPrivateProfile: boolean,
) => [
  "AVATAR",
  isPrivateProfile ? "ROLE" : "POSITION_AND_ROLE",
  "PHONE",
  "LOCATION",
  "CV",
  "SKILL",
  "LANGUAGE",
  // "WORKSTYLE",
  "ABOUT",
];

export const isCompletenessItemCompleted = (key: TCompletenessItemKey, completed: TCompletenessItemKey[]) => {
  if (key === "POSITION_AND_ROLE") {
    return completed.includes("POSITION") && completed.includes("ROLE");
  }

  return completed.includes(key);
};
